import { useState, useEffect } from "react";
import { useNavigate, generatePath, useParams } from "react-router-dom";
import http from "../../api/server";
import {
  DOOR_INSPECTION_API,
  // GET_PROPERTY_INFO_WITH_MASTER
  //GET_PROPERTY_USER_MAPPING,
  CONTRACT_INSPECTOR_ACCEPTANCE,
} from "../../api/apiPath";
import { useSelector } from "react-redux";
import Iframe from "react-iframe";
import { UserRoles, Statuses } from "../../components/common/constant";
import UploadPropertyImage from "./UploadPropertyImage";
import dayjs from "dayjs";
import Toaster from "./Toaster";
import StatusPill from "./StatusPill";

import orderNewicon from "../../assets/img/orderNew.png";
import orderDnldicon from "../../assets/img/orderDownloa.png";
import orderViewicon from "../../assets/img/order-view.png";
import orderUsericon from "../../assets/img/order-user.png";
import clocklogo from "../../assets/img/timelogo.png";
import editicon from "../../assets/img/disabledEditIcon.png";

const PropertyTile = (props) => {
  const { clientNameParam } = useParams();
  const [showLoader, setShowLoader] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [showPropertyImageModal, setShowPropertyImageModal] = useState(false);
  const { userObj } = useSelector((state) => state.user);
  const [showNewSurveyIcon, setShowNewSurveyIcon] = useState(false);
  const [showAcceptIcon, setShowAcceptIcon] = useState(false);
  const [showAcceptPopup, setShowAcceptPopup] = useState(false);
  const [acceptFormData, setAcceptFormData] = useState({
    status: "Select",
    comment: "",
  });
  const [validationFlag, setValidationFlag] = useState(false);
  const [showDownloadIcon, setShowDownloadIcon] = useState(false);
  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const {
    inspectionReferenceNumber,
    cityName,
    scheduledInspectionDate,
    // blockName,
    propertyMasterId,
    buildingId,
    buildingName,
    propertyName,
    propertyLocation,
    inspectedBy,
    //lastInspectionDate,
    // nextInspectionDueDate,
    status,
    // totalCompleted,
    // totalAttention,
    propertyImage,
    inspectionAccepted,
    inspectionMasterId,
  } = props.data;
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const navigate = useNavigate();
  const gotoDashBoard = (propertyId) => {
    const pathTemplate =
      "/client/:clientNameParam/scanNewDoor/:propertyMasterId/:inspectionRefnumber";
    //const pathTemplate = "/client/:clientNameParam/scanNewDoor/:propertyMasterId/:inspectionRefnumber";
    const params = {
      clientNameParam: clientNameParam,
      propertyMasterId: propertyId,
      inspectionRefnumber: inspectionReferenceNumber,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };

  useEffect(() => {
    getPropertyUserMapping();
  }, [props?.data]);
  // const handleDownloadClick = async () => {
  //   console.log("try download");
  //   setShowLoader(true);

  //   try {
  //     const response = await http.get(DOOR_INSPECTION_API, {
  //       responseType: "blob", // VERY IMPORTANT
  //     });

  //     // Create a link element
  //     const url = window.URL.createObjectURL(new Blob([response.data]));
  //     const link = document.createElement("a");setInspectorInspectionStatus
  //     link.href = url;

  //     // Optional: set a filename
  //     link.setAttribute(
  //       "download",
  //       "Heaton Newcastle_DoorInspectionReport.pdf"
  //     );

  //     // Append to DOM and trigger click
  //     document.body.appendChild(link);
  //     link.click();

  //     // Clean up
  //     link.remove();
  //     window.URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.error("Download Failed", error);
  //   } finally {
  //     setShowLoader(false);
  //   }
  // };
  const getPropertyUserMapping = async () => {
    // const propInfoResp = await http.get(
    //   GET_PROPERTY_USER_MAPPING + propertyMasterId
    // );
    // if (!propInfoResp.status) {
    //   throw new Error(`HTTP error! status: ${propInfoResp?.status}`);
    // }
    // var inspectorInspectionStatus = propInfoResp?.data?.filter(d => d.userId == userObj.userId)[0]?.status;

    // if ((((status !== Statuses.COMPLETED && status !== Statuses.REJECTED && status !== Statuses.SUBMITTEDFORAPPROVAL)
    //   && (inspectorInspectionStatus !== Statuses.COMPLETED))
    //   || (new Date(nextInspectionDueDate) <= new Date() && new Date(nextInspectionDueDate).getFullYear() > new Date().getFullYear()-1)) && props?.userRole === UserRoles.INSPECTOR) {
    //   setShowNewSurveyIcon(true);
    // } else {
    //   setShowNewSurveyIcon(false);
    // }
    // const response1 = await http.get(
    //   GET_PROPERTY_INFO_WITH_MASTER + propertyMasterId + "?InspectionReferenceNumber=" + inspectionReferenceNumber
    // );
    // if (!response1.status) {
    //   throw new Error(`HTTP error! status: ${response1?.status}`);
    // }
    // const inspection_status =
    const scheDate = new Date(scheduledInspectionDate);
    const todayDate = new Date();

    // Normalize to date-only strings
    const d1 = dayjs(scheDate).format("YYYY-MM-DD");
    const d2 = dayjs(todayDate).format("YYYY-MM-DD");

    // Compare as strings
    const isBeforeOrSame = d1 <= d2;
    console.log(isBeforeOrSame);

    if (
      (props?.userRole === UserRoles.INSPECTOR || props?.userRole === UserRoles.ADMIN) &&
      (status === Statuses.SCHEDULED || status === Statuses.INPROGRESS) &&
      isBeforeOrSame &&
      new Date(scheduledInspectionDate).getFullYear() >
        new Date().getFullYear() - 1
    ) {
      setShowNewSurveyIcon(true);
    } else {
      setShowNewSurveyIcon(false);
    }

    if (
      props?.userRole === UserRoles.INSPECTOR &&
      status === Statuses.PENDINGINSPECTORAPPROVAL &&
      inspectionAccepted === null
    ) {
      setShowAcceptIcon(true); //set to false for prod
    } else {
      setShowAcceptIcon(false);
    }
    console.log("status", showAcceptIcon);

    if (
      status !== Statuses.SCHEDULED &&
      status !== Statuses.New &&
      status !== null &&
      status !== undefined &&
      status !== Statuses.PENDINGINSPECTORAPPROVAL
    ) {
      setShowDownloadIcon(true);
    }
  };
    const handleImageUploadSuccess = (propId, InspRef, buildId) => {
      setShowPropertyImageModal(false);
      // setShowPropertyImageDetails(null);
      //go to scan qr code
      const pathTemplate =
        "/client/:clientNameParam/scanNewDoor/:propertyMasterId/:inspectionRefnumber";
  
      const params = {
        clientNameParam,
        propertyMasterId: propId,
        inspectionRefnumber: InspRef,
      };
  
      const fullPath = generatePath(pathTemplate, params);
      navigate(fullPath, {state: {buildingId: buildId}});
    };

  const handleDownloadClick = async (propertyId) => {
    setShowLoader(true);
    try {
      const response = await http.get(DOOR_INSPECTION_API, {
        params: {
          propertyId: propertyId,
        },
        responseType: "blob",
      });

      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);

      setPdfUrl(fileURL);
      if (isMobile) {
        const link = document.createElement("a");
        link.href = fileURL;
        link.download = `${propertyId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        setShowPdfModal(true); // 👉 show modal
      }
    } catch (error) {
      console.error("Download Failed", error);
    } finally {
      setShowLoader(false);
    }
  };

  // const handleDate = (datetime) => {
  //   if (datetime !== null && datetime !== undefined) {
  //     const date = new Date(datetime);
  //     const shortDate = date.toLocaleDateString("en-GB");
  //     return shortDate;
  //   }
  // };

  const gotoPropertyView = (propertyId) => {
    const pathTemplate =
      "/client/:clientNameParam/property-view-details/:propertyMasterId/:inspectionRefnumber";
    const params = {
      clientNameParam: clientNameParam,
      propertyMasterId: propertyId,
      inspectionRefnumber: inspectionReferenceNumber,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath, {
      state: { propertyInfo: props?.data, userRole: props?.userRole },
    });
  };

  const checkPropertyImage = (propertyImage) => {
    console.log("propertyImage", propertyImage);
    propertyImage?.trim() === "" || propertyImage === null
      ? setShowPropertyImageModal(true)
      : gotoDashBoard(propertyMasterId);
  };

  const handleCancel = () => {
    setShowPropertyImageModal(false);
  };

  const handleCancelAccept = () => {
    setValidationFlag(false);
    setShowAcceptPopup(false);
  };

  const handleFormDataChange = (e) => {
    setAcceptFormData({ ...acceptFormData, comment: e.target.value });
  };
  const handleStatusChange = (e) => {
    setAcceptFormData({
      ...acceptFormData,
      status: e.target.value,
    });
  };

  const handleAcceptValidation = async () => {
    let isValid = true;
    // Basic validation
    if (!acceptFormData.status || acceptFormData.status === "Select") {
      isValid = false;
    }
    if (
      acceptFormData.status === "Rejected" &&
      (!acceptFormData.comment || acceptFormData.comment.trim() === "")
    ) {
      isValid = false;
    }
    setValidationFlag(!isValid);
    if (isValid) {
      setShowLoader(true);
      const payload = {
        inspectorUserId: userObj?.userId,
        inspectionMasterId: inspectionMasterId,
        isAccepted: acceptFormData.status === "Accepted" ? true : false,
        rejectReason: acceptFormData.comment,
      };
      try {
        const response = await http.post(
          CONTRACT_INSPECTOR_ACCEPTANCE,
          payload,
        );
        console.log("Acceptance Response:", response, response.isSuccess);

        if (response.status === 200) {
          setShowLoader(false);
          setShowAcceptPopup(false);
          props.refreshPage();
          setTimeout(() => {
            props.refreshPage();
          }, 100);
          const message =
            acceptFormData.status === "Accepted"
              ? "Inspection accepted successfully."
              : "Inspection rejected successfully.";
          setTimeout(() => {
            setToastData({
              toastShow: true,
              toastType: "success",
              toastString: message,
            });
          }, 2000);
        } else {
          setShowLoader(false);
          setShowAcceptPopup(false);

          setTimeout(() => {
            setToastData({
              toastShow: true,
              toastType: "failure",
              toastString: "Error in submitting acceptance. Please try again.",
            });
          }, 2000);
        }
      } catch (err) {
        console.error("Error in submitting acceptance:", err);
        setShowLoader(false);
        setShowAcceptPopup(false);
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in submitting acceptance. Please try again.",
          });
        }, 2000);
      }
    }
  };

  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  return (
    <div className="row m-0 property-tile">
      <div className="col-12 col-sm-12 mb-3 p-0">
        <div className="order-card">
          <div className="p-4">
            <div className="d-flex flex-row justify-content-between">
              <p className="mb-1 fw-semibold" style={{ textAlign: "justify" }}>
                {buildingName ? buildingName :propertyName}
              </p>
              <StatusPill status={status} />
            </div>
            <div>
              <p className="text" style={{ textAlign: "justify" }}>
                {buildingName ? propertyName + ", " : ""  }
                {propertyLocation}
                {", "}
                {cityName}
              </p>
            </div>
            <div className="d-flex flex-row justify-content-between align-items-center">
              <p className="text" style={{ textAlign: "start" }}>
                <img src={orderUsericon} style={{ paddingRight: "3px" }}></img>
                {inspectedBy}
              </p>
              <p className=" text d-flex align-items-center mb-0 gap-2">
                <img
                  src={clocklogo} // replace with your image path
                  alt="Date"
                  width="16"
                  height="16"
                />
                <span className="info-value">
                  {scheduledInspectionDate
                    ? new Date(scheduledInspectionDate).toLocaleDateString(
                        "en-GB",
                        {
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                        },
                      )
                    : ""}
                </span>
              </p>
            </div>
          </div>
          <div className="order-card-buttons">
            <div
              className="order-button"
              onClick={() => {
                gotoPropertyView(propertyMasterId);
              }}
            >
              <img src={orderViewicon}></img>
              <p className="order-button-text mb-0 py-2">View</p>
            </div>
            {showLoader ? (
              <div className="loader"></div>
            ) : (
              showDownloadIcon && (
                <div
                  className="order-button"
                  onClick={() => {
                    handleDownloadClick(propertyMasterId);
                  }}
                >
                  <img src={orderDnldicon}></img>
                  <p className="order-button-text mb-0 py-2">Download</p>
                </div>
              )
            )}
            {showNewSurveyIcon && (
              <div
                className="order-button"
                onClick={() => {
                  checkPropertyImage(propertyImage);
                }}
              >
                <img src={orderNewicon}></img>
                <p className="order-button-text mb-0 py-2">New</p>
              </div>
            )}
            {showAcceptIcon && (
              <div
                className="order-button"
                onClick={() => {
                  setShowAcceptPopup(true);
                }}
              >
                <img
                  style={{ height: "14px", width: "14px" }}
                  src={editicon}
                ></img>
                <p className="order-button-text mb-0 py-2">Accept/Reject</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {showPdfModal && pdfUrl && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 1050,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "90%",
              maxHeight: "80vh",
              backgroundColor: "#fff",
              borderRadius: "8px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                padding: "10px 15px",
                borderBottom: "1px solid #ddd",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5 className="modal-title mb-0">PDF Preview</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  setShowPdfModal(false);
                  setPdfUrl(null);
                }}
              ></button>
            </div>
            <div style={{ height: "90vh", padding: 0 }}>
              <Iframe
                src={pdfUrl}
                width="100%"
                height="100%"
                title="PDF Preview"
                style={{
                  border: "none",
                  display: "block",
                  width: "100%",
                  height: "100%",
                }}
                frameBorder="0"
              ></Iframe>
            </div>
          </div>
        </div>
      )}
      {showPropertyImageModal && (
        <UploadPropertyImage
          propertyId={propertyMasterId}
          buildingid={buildingId}
          handleCancel={handleCancel}
          propertyName={propertyName}
          inspectionRefnumber={inspectionReferenceNumber}
          handleSuccess={handleImageUploadSuccess}
        />
      )}
      {showAcceptPopup && (
        <div className="modal-overlay">
          <div
            className="approval-modal-content"
            style={{ height: "fit-content" }}
          >
            <span className="close" onClick={handleCancelAccept}>
              &times;
            </span>
            <h6 className="modal-header">Pending Inspector Acceptance</h6>{" "}
            {/* Modal Header */}
            <div className="modal-body">
              <div>
                <p>
                  Please Accept the scheduled inspection for property :{" "}
                  {propertyName}
                </p>

                <div className="row">
                  <div className="col-sm-6 col-md-6 mb-3">
                    <div className="form-floating">
                      <select
                        className="form-select"
                        id="floatingSelect"
                        aria-label="Floating label select example"
                        value={acceptFormData.status}
                        onChange={handleStatusChange}
                      >
                        <option selected>Select</option>
                        <option value="Accepted">Accept</option>
                        <option value="Rejected">Reject</option>
                      </select>
                      <label htmlFor="floatingSelect">Status </label>
                    </div>
                  </div>
                </div>
                <div className="form-floating">
                  <textarea
                    className="form-control"
                    rows="5"
                    style={{ minHeight: "auto", height: "auto" }}
                    placeholder="Comments"
                    value={acceptFormData.comment}
                    id="floatingTextarea"
                    name="comment"
                    onChange={(e) => handleFormDataChange(e)}
                  ></textarea>
                  <label htmlFor="floatingTextarea">
                    Comments{" "}
                    {acceptFormData.status == "Rejected" ? (
                      <span style={{ color: "red" }}>*</span>
                    ) : (
                      ""
                    )}
                  </label>
                </div>
              </div>
              <div>
                {" "}
                {validationFlag && (
                  <small
                    style={{ color: "red", float: "left", width: "100%" }}
                    className=" mb-2"
                  >
                    * Please fill all required fields
                  </small>
                )}
              </div>
              <div className="row mt-3" style={{ marginRight: "0px" }}>
                {showLoader ? (
                  <div
                    className="approvalLoader"
                    style={{ marginLeft: "45%" }}
                  ></div>
                ) : (
                  <div>
                    <div className="card-body action_btns d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                          handleCancelAccept();
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => handleAcceptValidation()}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={() => {
          closeButton();
        }}
      />
    </div>
  );
};

export default PropertyTile;
